<div class="rich-instructions"
	[ngClass]="{'no-text': !instruction.text}"
	*ngIf="instruction.text || instruction.media">
	<h5 *ngIf="instruction.type" translate="{{ariaLabelTitleKey}}"></h5>
	<div
		[ngClass]="{'no-media' : !instruction.media}"
		class="instruction-section"
		*ngIf="instruction.text"
		[innerHTML]="richText">
	</div>
	<media-card
		*ngIf="instruction.media"
		[media]="instruction.media"
		[ariaLabelTitleKey]="ariaLabelTitleKey">
	</media-card>
</div>
